import type { ReactNode } from "react";

export default function SectionIntro({
  title,
  headline,
  colorPrimary,
  colorAccent = "hsl(48deg 100% 67%)",
  colorText = "#fff",
  icon: Icon,
}: {
  title: string;
  headline: ReactNode;
  colorPrimary: string;
  colorAccent?: string;
  colorText?: string;
  icon: () => JSX.Element;
}) {
  return (
    <header
      style={{
        // @ts-expect-error TS balks at custom properties
        "--colors-header-primary": colorPrimary,
        "--colors-header-text": colorText,
        "--colors-header-accent": colorAccent,
      }}
    >
      <div className="container">
        <Icon />
        <h1 className="word">{title}</h1>
        <h2 className="headline">{headline}</h2>
      </div>
      <style jsx>{`
        header {
          background-image: linear-gradient(#fff, #f7f7f9);
          padding: 48px 24px 0;
        }
        .container {
          position: relative;
          display: grid;
          column-gap: 16px;
          align-items: center;
        }
        .container :global(svg) {
          fill: var(--colors-header-primary);
          width: 76px;
          height: 76px;
        }
        .word {
          --font-size: 72px;
          --border-width: 2px;
          line-height: 1.25;
          font-size: var(--font-size);
          margin-bottom: 0;
          letter-spacing: -0.05em;
          text-indent: -0.04em;
        }
        .number {
          color: var(--colors-header-primary);
          border: 6px double currentColor;
          border-radius: 16px;
          width: calc(var(--font-size) * 0.875);
          height: calc(var(--font-size) * 0.875);
          line-height: 1.125;
          font-size: 0.625em;
          display: inline-block;
          text-align: center;
        }
        @media (min-width: 520px) {
          header {
            padding: 0 24px;
          }
          :global(section:not(:first-of-type)) header {
            padding-top: 48px;
          }
          .container {
            grid-template-columns: auto 1fr;
            column-gap: 32px;
          }
          .container :global(svg) {
            width: 92px;
            height: 92px;
          }
          .headline {
            grid-column: 2;
          }
          .word {
            --font-size: 84px;
          }
          .number {
            line-height: 1.2;
          }
        }
        .headline {
          color: #494e5a;
          opacity: 0.875;
          margin: 0;
          max-width: none;
          font-size: 24px;
          letter-spacing: -0.03em;
          z-index: initial;
        }
        @media (min-width: 1250px) {
          header {
            padding: 64px 48px 0;
          }
          :global(section:not(:first-of-type)) header {
            padding-top: 72px;
          }
          .headline {
            font-size: 42px;
          }
          .container {
            padding: 0 52px !important;
          }
        }
      `}</style>
    </header>
  );
}
